export default __webpack_public_path__ + "static/media/gallery_07.16fa615b.jpg";